'use client'

import { useEffect, useRef, useState } from 'react'

import { getCurrentUser } from '@src/quince-site-integrated/src/utils'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { isEmpty } from '@src/utils/functions/utils'

export function useGladlyChat() {
  const { name, email } = getCurrentUser() as { name: string; email: string }
  // Use MutableRefObject by using any type
  const gladlyRef = useRef<typeof window.Gladly | null>(null)
  const [gladlyLoaded, setGladlyLoaded] = useState(false)

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null

    timer = setInterval(() => {
      if (gladlyRef.current) {
        if (timer) clearInterval(timer)
        return
      }

      if (window.Gladly?.on) {
        // Use type assertion to override readonly
        gladlyRef.current = window.Gladly
        setGladlyLoaded(true)

        if (timer) clearInterval(timer)
      }
    }, 100)

    return () => {
      clearInterval(timer)
    }
  }, [])

  useEffect(() => {
    let unsubscribe: (() => void) | undefined = undefined
    if (gladlyLoaded && gladlyRef.current) {
      unsubscribe = gladlyRef.current.on('sidekick:opened', (properties: Record<string, unknown>) => {
        console.info('Gladly sidekick:opened', { properties })
        trackEvent(TELEMETRY_EVENT_NAMES.SUPPORT_CHAT_INITIATED, {})
      })
    }

    return () => {
      if (unsubscribe) {
        unsubscribe()
      }
    }
  }, [gladlyLoaded])

  const setGladlyUser = () => {
    if (email && !isEmpty(window.Gladly?.getUser())) {
      try {
        window.Gladly?.setUser({ name, identity: email, identityType: 'EMAIL' })
      } catch (error) {
        console.error(error)
      }
    }
  }

  const openChat = () => {
    try {
      window.Gladly?.show()
      trackEvent(TELEMETRY_EVENT_NAMES.CHAT_WITH_US_CLICKED, {})
      setGladlyUser()
    } catch (error) {
      console.error(error)
    }
  }

  return { openChat }
}
